export const formatUTCTime = (timestamp) => {
  if (!timestamp || isNaN(new Date(timestamp).getTime())) return '-';
  return new Date(timestamp).toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const formatUTCDate = (date) => {
  if (!date || isNaN(new Date(date).getTime())) return '-';
  return new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' });
};

export const isValidDate = (dateString) => {
  if (!dateString) return false;
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};